import React from "react";
import CardTemplate from "@appsinti/ui-core/CardTemplate";
import { MetricData } from "@appsinti/ui-core/styles";
import { RIGHT_DARK, WRONG_DARK } from "@etiquette-ui/colors";
import { CardTitleComponent, CustomRow } from "../../../styles";
import { formatPercentage } from "@appsinti/common-utils";
import StatsDay from "../../../../../../../interfaces/StatsDay";

const CashCancellationsCourtesy: React.FC<{ day: StatsDay }> = ({ day }) => {
  return (
    <CardTemplate
      background={"white"}
      noPadding={true}
      header={
        <CustomRow>
          <CardTitleComponent title={"Cash %"} />
          <CardTitleComponent title={"Cancellation %"} />
          <CardTitleComponent title={"Courtesy %"} />
        </CustomRow>
      }
      body={
        <CustomRow>
          <div className="column">
            <MetricData size={"bigger"} weight={"bold"} color={RIGHT_DARK}>
              {formatPercentage(day.salesData.total.cash, 1)}
            </MetricData>
          </div>
          <div className="column">
            <MetricData size={"bigger"} weight={"bold"} color={WRONG_DARK}>
              {formatPercentage(day.salesData.total.cancellation, 1)}
            </MetricData>
          </div>
          <div className="column">
            <MetricData size={"bigger"} weight={"bold"} color={WRONG_DARK}>
              {formatPercentage(day.salesData.total.courtesy, 1)}
            </MetricData>
          </div>
        </CustomRow>
      }
    />
  );
};

export default CashCancellationsCourtesy;
